module.exports = __webpack_public_path__ + "img/Frame 5.eef5dc4c.png";